export default [
  { text: "tipopago.CUOTA", value: "CUOTA" },
  { text: "tipopago.POV", value: "POV" },
  { text: "tipopago.PEV", value: "PEV" },
  { text: "tipopago.PEB", value: "PEB" },
  { text: "tipopago.OTROS", value: "OTROS" },
];
